import { combineReducers } from '@reduxjs/toolkit';
import state from './stateSlice';

const menuDialogReducer = combineReducers({ state });
export default menuDialogReducer;
